import { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import { getToken, validateAdmin } from "../../utils/helper";
import { getTolerance } from "../../utils/actions/allactions";
import { useNavigate } from "react-router-dom";
import useDocumentTitle from "../../utils/useDocumentTitle";
import AdminLoadingComponent from "../../components/LoadingComponents/AdminLoadingComponent";
import Button from "../../components/Button/Button";
import { toast } from "react-toastify";
import AdminDashboardComponents from "../../components/HigherOrderComponents/AdminDashboardComponents";
const ToleranceMaster = () => {
  let navigate = useNavigate();
  useDocumentTitle("Tolerance Master");
  const [data, setData] = useState(null);
  let token = getToken();

  const fetchToleranceData = async () => {
    try {
      const toleranceData = await getTolerance(token);
      setData(toleranceData);
    } catch (error) {
      toast.error("Data fetch failed. Please try again later");
    }
  };
  useEffect(() => {
    validateAdmin(token, navigate);
    fetchToleranceData();
  }, []);

  const handleCreateNew = () => {
    navigate("/admin/add-tolerance-master");
  };

  const handleEditToleranceMaster = (id) => {
    navigate(`/admin/edit-tolerance-master?id=${id}`);
  };

  return (
    <div className="admin-container">
      
      <div className="right-container">
        <div className="center-heading">
          <h1 className="font-bold text-2xl"> Tolerance Master </h1>
          <div className="search-bar">
            <div className="row">
              <div className="col-md-9"></div>
              <div className="col-md-3">
                <div className="search-btn">
                  <button onClick={handleCreateNew} className="pr-edit-btn">
                    Create New
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="quotes-table">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col" style={{ cursor: "pointer" }}>
                    Name{" "}
                  </th>
                  <th scope="col" style={{ cursor: "pointer" }}>
                    Tolerance Factor
                  </th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              {data ? (
                <tbody>
                  {data.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>{item.name || ""}</td>
                        <td>{item.TolFactor || "NA"}</td>
                        <td>
                          <Button
                            onClickFunction={() =>
                              handleEditToleranceMaster(item._id)
                            }
                            text={"Edit / Deactivate"}
                            additionalClassName={
                              "border-red-500  px-4 py-2 bg-yellow-500 shadow-sm text-white rounded text-sm"
                            }
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : (
                <AdminLoadingComponent rows={8} columns={3} />
              )}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardComponents(ToleranceMaster);
